const SCROLL_KEY = 'home_scroll_y'
const PENDING_KEY = 'home_scroll_restore_pending'

export function getScrollTop() {
  return (
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0
  )
}

export function saveHomeScrollPosition() {
  sessionStorage.setItem(SCROLL_KEY, String(getScrollTop()))
  sessionStorage.setItem(PENDING_KEY, '1')
}

export function shouldRestoreHomeScroll() {
  return sessionStorage.getItem(PENDING_KEY) === '1'
}

function clearHomeScrollState() {
  sessionStorage.removeItem(SCROLL_KEY)
  sessionStorage.removeItem(PENDING_KEY)
}

export function restoreHomeScrollPosition() {
  if (!shouldRestoreHomeScroll()) {
    return Promise.resolve(false)
  }

  const raw = sessionStorage.getItem(SCROLL_KEY)
  if (raw == null) {
    clearHomeScrollState()
    return Promise.resolve(false)
  }

  const targetY = Number(raw)
  if (!Number.isFinite(targetY) || targetY < 0) {
    clearHomeScrollState()
    return Promise.resolve(false)
  }

  return new Promise((resolve) => {
    let attempts = 0
    const maxAttempts = 20

    const apply = () => {
      window.scrollTo({ top: targetY, left: 0, behavior: 'auto' })
      document.documentElement.scrollTop = targetY
      document.body.scrollTop = targetY
    }

    const tryRestore = () => {
      apply()
      attempts += 1
      const diff = Math.abs(getScrollTop() - targetY)
      if (diff < 3 || attempts >= maxAttempts) {
        clearHomeScrollState()
        resolve(true)
        return
      }
      setTimeout(tryRestore, 80)
    }

    requestAnimationFrame(() => {
      tryRestore()
    })
  })
}

export function scrollPageToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}
